<app-loader [isLoading]="isLoading"></app-loader>
<div class="container d-flex flex-column">
  <div class="heading-div d-flex justify-content-between">
    <span class="fc-content">Filter</span>
    <div class="img-div" (click)="closeDialog()">
      <img alt="cross" class="img-cross" src="../../../assets/images/cross_white.svg" />
    </div>
  </div>
  <div class="d-flex flex-column" style="gap: 16px">
    <!-- <span class="content">Custom date range</span> -->
    <!-- <div class="d-flex flex-column" style="gap: 4px">
      <span class="input-text">From Date</span>
      <dp-datepicker [formControl]="fromDate" placeholderLevel="dd/mm/yyyy"
        datePickerClass="datepicker"></dp-datepicker>
    </div>
    <div class="d-flex flex-column" style="gap: 4px">
      <span class="input-text">To Date</span>

      <dp-datepicker [formControl]="toDate" placeholderLevel="dd/mm/yyyy" datePickerClass="datepicker"></dp-datepicker>
    </div> -->
    <div class="d-flex flex-column" style="gap: 4px">
      <span class="input-text">Pincode</span>
      <div class="state-filter">
        @if(pinList.length>=1){
        <input class="search-input dp-input-control" type="tel" placeholder="Enter Pincode" aria-label="Search"
          [formControl]="pin" maxlength="6" [matAutocomplete]="autopin" />
        <mat-autocomplete autoActiveFirstOption #autopin="matAutocomplete">
          @for (item of pinList ; track item) {
          <mat-option [value]="item">{{
            item
            }}</mat-option>
          }
        </mat-autocomplete>
        }@else{
        <input class="search-input dp-input-control" type="tel" placeholder="Enter Pincode" aria-label="Search"
          [formControl]="pin" maxlength="6" />
        }
      </div>
    </div>
    <div class="d-flex gap-2 filter-div">
      <div class="d-flex flex-column" style="gap: 4px; width:100%">
        <span class="input-text">State</span>
        <div class="state-filter">
          <mat-form-field class="select-mat-form-field custom-select-form">
            <mat-select class="custom-mat-select custom-select" id="state" placeholder="Select State"
              [formControl]="stateName">
              <mat-option *ngFor="let state of stateList; let i=index" [value]="state.state"
                (click)="onStateChange(state.state, i)">
                {{ state.state }}
              </mat-option>
            </mat-select>
            @if(stateName.value!==''){
            <button mat-icon-button matSuffix (click)="clearState()" class="clear-button">
              <mat-icon class="clear-icon">clear</mat-icon>
            </button>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="d-flex flex-column" style="gap: 4px; width:100%">
        <span class="input-text">District</span>
        <div class="state-filter">
          <mat-form-field class="select-mat-form-field custom-select-form">
            <mat-select class="custom-mat-select custom-select" id="district" placeholder="Select district"
              [formControl]="districtName">
              <mat-option *ngFor="let district of districtList" [value]="district" (click)="onDistrictChange(district)">
                {{ district }}
              </mat-option>
            </mat-select>
            @if(districtName.value!==''){
            <button mat-icon-button matSuffix (click)="clearDistrict()" class="clear-button">
              <mat-icon class="clear-icon">clear</mat-icon>
            </button>
            }
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="d-flex gap-2 filter-div">
      <div class="d-flex flex-column" style="gap: 4px; width:100%">
        <span class="input-text">Member Status</span>
        <div class="state-filter">
          <mat-form-field class="select-mat-form-field custom-select-form">
            <mat-select class="custom-mat-select custom-select" placeholder="Select Status" [formControl]="memStatus">
              @for(item of memStatusList;track item){
              <mat-option [value]="item.value" (click)="onMemStatusChange(item)">
                {{ item.value }}
              </mat-option>
              }
            </mat-select>
            @if(memStatus.value!==''){
            <button mat-icon-button matSuffix (click)="clearMemStatus()" class="clear-button">
              <mat-icon class="clear-icon">clear</mat-icon>
            </button>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="d-flex flex-column " style="gap: 4px; width:100%">
        <span class="input-text">Record Status</span>
        <div class="state-filter">
          <mat-form-field class="select-mat-form-field custom-select-form">
            <mat-select class="custom-mat-select custom-select" placeholder="Select Status" [formControl]="recStatus">
              @for(item of recordStatusList;track item){
              <mat-option [value]="item.value" (click)="onRecStatusChange(item)">
                {{ item.value }}
              </mat-option>
              }
            </mat-select>
            @if(recStatus.value!==''){
            <button mat-icon-button matSuffix (click)="clearRecStatus()" class="clear-button">
              <mat-icon class="clear-icon">clear</mat-icon>
            </button>
            }
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="d-flex gap-2 filter-div">

        <div class="d-flex flex-column" style="gap: 4px; width: 100%;">
      <span class="input-text">From Date</span>
      <dp-datepicker [formControl]="fromDate" placeholderLevel="dd/mm/yyyy"
        datePickerClass="datepicker"></dp-datepicker>
    </div>
    <div class="d-flex flex-column" style="gap: 4px; width: 100%;">
      <span class="input-text">To Date</span>

      <dp-datepicker [formControl]="toDate" placeholderLevel="dd/mm/yyyy" datePickerClass="datepicker"></dp-datepicker>
    </div>
    </div>
  </div>

  <div class="btn-div">
    <button class="clear-btn" (click)="onClear()">
      Clear
    </button>
    <button class="dp-primary-btn inp-div" (click)="onApplyClick()">
      Apply Filters
    </button>
  </div>
</div>